<template>
  <section v-on:click="sectionClicked" class="features gallery" :class="section.id">
    <div ref="gHelper"></div>
    <div class="cnt">
      <div class="sectionHeader" v-if="section.title[lang] || section.descriptions[lang]">
        <h4 class="sectionTitle" v-if="section.title[lang]">{{section.title[lang]}}</h4>
        <p class="sectionDesc" v-if="section.descriptions[lang]">{{section.descriptions[lang]}}</p>
      </div>
    </div>
    <div class="galleryDynamicCnt" v-if="section.config.galleryDisplayType === 'Dynamic'">
      <div class="cnt">
        <div class="galleryDynamic">
          <div class="galleryItem" :class="`s${i}`"
            v-for="(item, i) in section.items" :key="`g1${i}`">
            <div class="galleryImg" v-if="item.imageSm"
              :style="{'background-image': `url(${item.imageSm})`}"
              v-on:click="previewImg({e: $event, item, i, items: section.items})"></div>
            <div class="galleryImg noImg" v-else></div>
          </div>
        </div>
      </div>
    </div>
    <div class="galleryCnt" v-else>
      <div class="gallerySc" :style="{'margin-left': `${gOffset}px`}">
        <div class="galleryWrapper gallery1">
          <div class="galleryItem" :class="`s${i}`"
            v-for="(item, i) in section.items.slice(0, 6)" :key="`g1${i}`">
            <div class="galleryImg" v-if="item.imageSm"
              :style="{'background-image': `url(${item.imageSm})`}"
              v-on:click="previewImg({e: $event, item, i, items: section.items})"></div>
            <div class="galleryImg noImg" v-else></div>
          </div>
        </div>
      </div>
      <div class="gallerySc" :style="{'margin-left': `${-gOffset}px`}">
        <div class="galleryWrapper gallery2">
          <div class="galleryItem" :class="`s${i + 6}`"
            v-for="(item, i) in section.items.slice(6, 12)" :key="`g2${i}`">
            <div class="galleryImg" v-if="item.imageSm"
              :style="{'background-image': `url(${item.imageSm})`}"
              v-on:click="previewImg({e: $event, item, i, items: section.items})"></div>
            <div class="galleryImg noImg" v-else></div>
          </div>
        </div>
      </div>
      <div class="gallerySc" :style="{'margin-left': `${gOffset}px`}"
        v-if="section.items.length > 12">
        <div class="galleryWrapper gallery3">
          <div class="galleryItem" :class="`s${i + 12}`"
            v-for="(item, i) in section.items.slice(12, 18)" :key="`g2${i}`">
            <div class="galleryImg" v-if="item.imageSm"
              :style="{'background-image': `url(${item.imageSm})`}"
              v-on:click="previewImg({e: $event, item, i, items: section.items})"></div>
            <div class="galleryImg noImg" v-else></div>
          </div>
        </div>
      </div>
    </div>
    <ImageViewer ref="imageViewer"/>
  </section>
</template>

<script>
import ImageViewer from '@/components/ImageViewer.vue';

export default {
  name: 'home',
  props: ['section'],
  components: { ImageViewer },
  data() {
    return {
      gOffset: 0,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    scrolled() {
      const factor = (window.screen.width >= 769) ? 0.4 : 0.14;
      const offsetTop = this.$refs.gHelper.getBoundingClientRect().top + window.scrollY;
      this.gOffset = -(window.scrollY - (offsetTop - 600)) * factor;
      if (this.gOffset > 40) this.gOffset = 40;
    },
    previewImg(data) {
      this.section.modalOpen = true;
      this.$refs.imageViewer.open(data, () => {
        this.section.modalOpen = false;
      });
    },
  },
  created() { document.addEventListener('scroll', this.scrolled); },
  destroyed() { document.removeEventListener('scroll', this.scrolled); },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.galleryCnt{
  overflow: hidden;
  @media (max-width: 680px) {
    padding-bottom: 20px;
  }
}
.galleryDynamic{
  display: flex;
  flex-wrap: wrap;
  margin: 0 -16px;
  @media (max-width: 960px) {
    margin: 0 -10px;
  }
  .galleryItem{
    width: 25%;
    padding: 0 16px 32px;
    @media (max-width: 980px) {
      width: 33.33333%;
    }
    @media (max-width: 960px) {
      padding: 0 10px 20px;
    }
    @media (max-width: 768px) {
      width: 50%;
    }
    .galleryImg{
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 7px;
      height: 240px;
      transition: all .3s ease;
      cursor: pointer;
      @media (max-width: 1280px) {
        height: 18vw;
      }
      @media (max-width: 980px) {
        height: 20vw;
      }
      @media (max-width: 768px) {
        height: 30vw;
      }
      &:hover{
        transform: scale(1.06);
      }
    }
  }
}
.galleryWrapper{
  background-size: auto 100%;
  background-repeat: no-repeat;
  display: flex;
  width: 144vw;
  padding: 15px 0;
  @media (max-width: 1040px) {
    padding: 10px 0;
  }
  @media (max-width: 740px) {
    padding: 5px 0;
  }
  .galleryItem{
    background-color: #eee;
    width: calc(24vw - 30px);
    margin-right: 30px;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    transition: all .3s ease;
    height: 240px;
    @media (max-width: 1480px) {
      height: 200px;
    }
    @media (max-width: 1280px) {
      height: 160px;
    }
    @media (max-width: 1040px) {
      height: 140px;
      width: calc(24vw - 20px);
      margin-right: 20px;
    }
    @media (max-width: 740px) {
      height: 120px;
      width: calc(24vw - 10px);
      margin-right: 10px;
    }
    @media (max-width: 540px) {
      width: 100%;
      height: 94px;
    }
    &.s4, &.s5, &.s10, &.s11{
      @media (max-width: 540px) {
        display: none;
      }
    }
    &:hover{
      transform: scale(1.04);
    }
    .galleryImg{
      background-position: center;
      background-size: cover;
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
    }
  }
  &.gallery1{
  }
  &.gallery2{
    margin-left: calc(-44vw + 40px);
  }
}

.features.gallery.kampanye-bergerak-gallery-mural{
  background-color: #486CB1;
  position: relative;
  color: #fff;
  margin: 0 0 200px;
  padding: 0;
  @media (max-width: 960px) {
    margin: 0 0 100px;
  }
  @media (max-width: 540px) {
    margin: 0 0 50px;
  }
  &:after{
    content: "";
    position: absolute;
    height: 200px; bottom: -200px;
    left: 0; right: 0;
    background-image: url(../../assets/blue-divider-bottom.png);
    background-size: 100% auto;
    background-position: top center;
    background-repeat: no-repeat;
  }
}

.features.gallery.kampanye-bergerak-gallery-bersepeda{
  padding-top: 0;
}
</style>
